exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ljr-accordion-list .panel-group .panel{border-radius:15px;border:1px solid #dedede}.ljr-accordion-list .panel-heading{background-color:#fff;border-radius:15px;border-color:inherit;padding:10px 20px 10px 30px;border-bottom-left-radius:15px;border-bottom-right-radius:15px;border-bottom:1px solid #dedede}.ljr-accordion-list .panel-heading .panel-title>a{display:inline-block;width:100%;font-size:22px;line-height:36px}.ljr-accordion-list .panel-heading .panel-title>a>i{float:right;font-size:35px}.ljr-accordion-list .panel-heading.active{background-color:#0060c6}.ljr-accordion-list .panel-heading.active .panel-title>a{color:#fff}.ljr-accordion-list .text-content{padding:20px;object-fit:contain;white-space:break-spaces;font-size:18px}.ljr-accordion-list .panel-default>.panel-heading+.panel-collapse>.panel-body{border-top:0}@media (max-width:768px){.ljr-accordion-list{padding:0 20px}.ljr-accordion-list .panel-heading{border-radius:10px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/features/commons/AccordionList/AccordionList.scss
// module id = 1109
// module chunks = 0